import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { ShopByCategory } from '../components/ShopByCategory';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { BrowseCollection } from '../components/BrowseCollection';
import { MemorabiliaBanner } from '../components/MemorabiliaBanner';
import { WhyBucknut } from '../components/WhyBucknut';
import { Newsletter } from '../components/Newsletter';
import { Footer } from '../components/Footer';
export const Home = () => {
  return <div className="min-h-screen flex flex-col w-full" data-id="element-161">
      <Header data-id="element-162" />
      <main className="flex-grow" data-id="element-163">
        <Hero data-id="element-164" />
        <TrustBar data-id="element-165" />
        <ShopByCategory data-id="element-166" />
        <FeaturedProducts data-id="element-167" />
        <BrowseCollection data-id="element-168" />
        <MemorabiliaBanner data-id="element-169" />
        <WhyBucknut data-id="element-170" />
        <Newsletter data-id="element-171" />
      </main>
      <Footer data-id="element-172" />
    </div>;
};